import { DIFFICULTY_NAMES } from '../config/generation-config';
/**
 * The reward tier for a score, using the config's ascending thresholds. Falls
 * back to the board's own band when scaling is switched off, or when the level
 * has no score at all (a fallback board).
 */
export function rewardTierForScore(config, score, band) {
    if (!config.rewards.scaleWithScore || score === null)
        return band;
    let tier = DIFFICULTY_NAMES[0];
    for (const step of config.rewards.scoreTiers) {
        if (score >= step.minScore)
            tier = step.tier;
    }
    return tier;
}
